import { AppContext } from "@lightspeed-invoicing/core-client/frontend";
import $ from "jquery";
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import EventBus from '../common/EventBus.js';
import ActionButton from "../common/button/actionbutton.component.jsx";
const uuidv4 = require('uuid/v4')

class InvoiceExportModal extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            exportType: this.props.exportType || 'invoices',
            modalId: this.props.modalId || 'export-invoices-modal-' + uuidv4(),
            includeItems: false,
            filters: this.props.filters,
        }
        this.closeModal = this.closeModal.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
        this.submit = this.submit.bind(this)
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            filters: nextProps.filters,
        })
    }

    componentDidMount() {
        $('#' + this.state.modalId).modal('show')
    }

    closeModal(event) {
        event?.preventDefault()
        $('#' + this.state.modalId).modal('hide')
        if (this.props.onClose) {
            this.props.onClose(event)
        }
    }

    handleFormChange(event) {
        const checked = event.target.checked
        this.setState({
            includeItems: checked
        })
    }

    submit(e) {
        e.preventDefault()
        AppContext.getApiClient().post('/batch-exports', {
            integrationKey: 'csv',
            type: this.state.exportType,
            filters: this.state.filters,
            metadata: {
                includeItems: this.state.includeItems
            }
        }).then(res => {
            if (res.error) {
                return
            }
            EventBus.dispatch(EventBus.TopicSendSuccessNotification, {
                message: <FormattedMessage
                    id="listing.search.export_created_csv_message"
                    defaultMessage="Export started successfully. A CSV file will be sent to {email}"
                    values={{
                        email: <strong>{AppContext.getUserLoggedIn().attributes.email}</strong>
                    }}
                />
            })
        })
        this.closeModal()
    }

    render() {
        return <div className="modal fade"
            id={this.state.modalId}
            role="dialog"
            aria-labelledby="invoiceExportModalTitle"
            data-backdrop="static"
            data-keyboard="false"
            tabIndex="-1"
        >
            <div className="modal-dialog modal-dialog-scrollable" role="document">
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="container-fluid">
                            <p className={"p-2 text-left"}>
                                <FormattedMessage
                                    id="listing.search.export_message"
                                    defaultMessage="Your export will be sent to {email} as a CSV file and can take a few minutes to create. Do you want to proceed?"
                                    values={{
                                        email: <strong>{AppContext.getUserLoggedIn().attributes.email}</strong>
                                    }}
                                />
                            </p>
                            <div className="custom-control custom-checkbox">
                                <input type="checkbox"
                                    className="custom-control-input"
                                    id={'includeItems'}
                                    value={this.state.includeItems}
                                    name={'includeItems'}
                                    checked={this.state.includeItems}
                                    onChange={this.handleFormChange}
                                />
                                <label className="custom-control-label" htmlFor={'includeItems'}>
                                    <FormattedMessage
                                        id="invoice.modal.export.include_items_label"
                                        defaultMessage="Include line items"
                                    />
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={this.closeModal}>
                            <FormattedMessage
                                id="invoice.void_modal.close_btn"
                                defaultMessage="Close"
                            />
                        </button>
                        <ActionButton
                            type="button"
                            className="btn btn-primary"
                            onClick={this.submit}
                        >
                            <FormattedMessage
                                id="invoice.modal.export.start_btn"
                                defaultMessage="Start export"
                            />
                        </ActionButton>
                    </div>
                </div>
            </div>
        </div>
    }
}

export default injectIntl(InvoiceExportModal)



// WEBPACK FOOTER //
// ./src/invoice/exportmodal.component.jsx